import styled from "styled-components/native";
import { spacers } from "~/styles/theme";

export const HeaderContainer = styled.View``;

export const WebHeaderContainer = styled.View`
  padding-top: ${spacers.ss4}px;
`;
